import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import * as constants from '../globalHeader/constants';
export var LINK_PROP_TYPE = constants.LINK_PROP_TYPE;
export var LINKS_PROP_TYPE = constants.LINKS_PROP_TYPE;
export var SECTION_PROP_TYPE = PropTypes.shape({
  title: EBPropTypes.translation,
  links: LINKS_PROP_TYPE
});
export var SECTIONS_PROP_TYPE = PropTypes.arrayOf(SECTION_PROP_TYPE);